/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate } from "../../funcs/dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$inboundSchema
    .optional(),
};

export const tool$dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate:
  ToolDefinition<typeof args> = {
    name:
      "daily-stats-get-api-v3-max-update-transactions-per-sec-till-date",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
